import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-metiers-item',
  templateUrl: './metiers-item.component.html',
  styleUrls: ['./metiers-item.component.scss']
})
export class MetiersItemComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
